import { Autocomplete } from '@material-ui/lab';
import { TextInput } from '@room-match/shared-ui-components';
import coat from 'data/new/CoatSize.json';
import dresssize from 'data/new/DressSize.json';
import hipSize from 'data/new/HipSize.json';
import suitSize from 'data/new/SuitSize.json';
import { FormikProps } from 'formik/dist/types';
import React from 'react';
import { ITalentUpdatePayload } from 'shared/interfaces/ITalent';
import CompCardButton from '../CompCardButton';
import { useStyles } from '../SizeCard.styles';
import cupsize from 'data/new/CupSize.json';
interface Props {
  form: FormikProps<ITalentUpdatePayload>;
  filterOptions: any;
  filteredChestOptions: any[];
  filteredWaistOptions: any[];
  filteredShoeOptions: any[];
  filteredInseamOptions: any[];
  filteredNeckOptions: any[];
  sleeveOption: any[];
  filteredHatOptions: any[];
  filteredGloveOptions: any[];
  filteredBustOptions: any[];
  metricValue: string;
  compCardAdd?: (arg0: { key: string; value: string }) => void;
  compCardRemove?: (arg0: { key: string }) => void;
  requiredOnly?: boolean;
  requiredFields?: string[];
  nonRequiredFields?: boolean;
  showNonRequiredFields?: string[];
}

const NonBinary: React.FC<Props> = ({
  form,
  filteredInseamOptions,
  filteredNeckOptions,
  filterOptions,
  filteredShoeOptions,
  filteredChestOptions,
  filteredWaistOptions,
  filteredHatOptions,
  filteredGloveOptions,
  sleeveOption,
  metricValue,
  filteredBustOptions,
  compCardAdd,
  compCardRemove,
  requiredOnly,
  requiredFields,
  nonRequiredFields = false,
  showNonRequiredFields = [],
}) => {
  const classes = useStyles();
  const show = (field: string) =>
    (requiredFields?.includes(field) && !nonRequiredFields) ||
    (nonRequiredFields && !requiredOnly && !requiredFields?.includes(field)) ||
    !!showNonRequiredFields?.includes(field);

  const isRequired = (field: string) => requiredFields?.includes(field) && !nonRequiredFields;
  return (
    <React.Fragment>
      {show('chest_size') && (
        <div>
          <CompCardButton
            attributes={{ label: 'Chest Size', key: 'chest_size_non_binary' }}
            onClick={compCardAdd}
            hasValue={form.values.statistics?.chest_size !== '' && form.values.statistics?.chest_size !== null}
          />
          <Autocomplete
            id="SC-chestSize"
            filterOptions={filterOptions}
            onChange={(e, newValue, reason) => {
              if (compCardRemove && reason === 'clear') {
                compCardRemove({ key: 'chest_size_non_binary' });
              }
              form.setFieldValue('statistics.chest_size', newValue);
            }}
            value={form.values.statistics?.chest_size}
            options={filteredChestOptions}
            getOptionSelected={(option, value) => option === value}
            fullWidth
            classes={{
              option: classes.option,
            }}
            renderInput={(params) => (
              <TextInput
                {...params}
                InputProps={{
                  ...params.InputProps,
                  classes: {
                    root: classes.textInputStyle,
                  },
                }}
                placeholder={'Select Chest Size'}
                errorMessage={
                  isRequired('chest_size') && !form.values.statistics?.chest_size ? 'Chest size is required' : ''
                }
              />
            )}
          />
        </div>
      )}
      {show('cup_size') ? (
        <div>
          <CompCardButton
            attributes={{
              label: 'Cup Size',
              key: 'cup_size',
            }}
            onClick={compCardAdd}
            hasValue={form.values.statistics?.cup_size !== '' && form.values.statistics?.cup_size !== null}
          />
          <Autocomplete
            filterOptions={filterOptions}
            onChange={(e, newValue, reason) => {
              if (compCardRemove && reason === 'clear') {
                compCardRemove({ key: 'cup_size' });
              }
              form.setFieldValue('statistics.cup_size', newValue);
            }}
            value={form.values.statistics?.cup_size}
            options={cupsize.map((j) => j.value)}
            getOptionSelected={(option, value) => option === value}
            fullWidth
            classes={{
              option: classes.option,
            }}
            renderInput={(params) => (
              <TextInput
                {...params}
                placeholder={'Select Cup Size'}
                InputProps={{
                  ...params.InputProps,
                  classes: {
                    root: classes.textInputStyle,
                  },
                }}
                errorMessage={
                  isRequired('cup_size') && form.values.adult_minor === 'adult' && !form.values.statistics?.cup_size
                    ? 'Cup size is required'
                    : ''
                }
              />
            )}
          />
        </div>
      ) : (
        <React.Fragment />
      )}
      {show('bust_size') && (
        <div>
          <CompCardButton
            attributes={{ label: 'Bust Size', key: 'bust_size' }}
            onClick={compCardAdd}
            hasValue={form.values.statistics?.bust_size !== '' && form.values.statistics?.bust_size !== null}
          />
          <Autocomplete
            onChange={(e, newValue, reason) => {
              if (compCardRemove && reason === 'clear') {
                compCardRemove({ key: 'bust_size' });
              }
              form.setFieldValue('statistics.bust_size', newValue);
            }}
            value={form.values.statistics?.bust_size}
            options={filteredBustOptions}
            getOptionSelected={(option, value) => option === value}
            fullWidth
            classes={{
              option: classes.option,
            }}
            renderInput={(params) => (
              <TextInput
                {...params}
                InputProps={{
                  ...params.InputProps,
                  classes: {
                    root: classes.textInputStyle,
                  },
                }}
                placeholder={'Select Bust Size'}
                errorMessage={
                  isRequired('bust_size') && !form.values.statistics?.bust_size ? 'Bust size is required' : ''
                }
              />
            )}
          />
        </div>
      )}
      {show('waist') && (
        <div>
          <CompCardButton
            attributes={{ label: 'Waist', key: 'waist' }}
            onClick={compCardAdd}
            hasValue={form.values.statistics?.waist !== '' && form.values.statistics?.waist !== null}
          />
          <Autocomplete
            id="SC-waist"
            filterOptions={filterOptions}
            onChange={(e, newValue, reason) => {
              if (compCardRemove && reason === 'clear') {
                compCardRemove({ key: 'waist' });
              }
              form.setFieldValue('statistics.waist', newValue);
            }}
            value={form.values.statistics?.waist}
            options={filteredWaistOptions}
            getOptionSelected={(option, value) => option === value}
            fullWidth
            classes={{
              option: classes.option,
            }}
            renderInput={(params) => (
              <TextInput
                {...params}
                InputProps={{
                  ...params.InputProps,
                  classes: {
                    root: classes.textInputStyle,
                  },
                }}
                placeholder={'Select Waist'}
                errorMessage={isRequired('waist') && !form.values.statistics?.waist ? 'Waist is required' : ''}
              />
            )}
          />
        </div>
      )}
      {show('hip_size') && (
        <div>
          <CompCardButton
            attributes={{ label: 'Hip Size', key: 'hip_size' }}
            onClick={compCardAdd}
            hasValue={form.values.statistics?.hip_size !== '' && form.values.statistics?.hip_size !== null}
          />
          <Autocomplete
            onChange={(e, newValue, reason) => {
              if (compCardRemove && reason === 'clear') {
                compCardRemove({ key: 'hip_size' });
              }
              form.setFieldValue('statistics.hip_size', newValue);
            }}
            value={form.values.statistics?.hip_size}
            options={hipSize.map((i) => (metricValue === 'AL' ? i.im : metricValue === 'CM' ? i.metric : i.imperial))}
            getOptionSelected={(option, value) => option === value}
            fullWidth
            classes={{
              option: classes.option,
            }}
            renderInput={(params) => (
              <TextInput
                {...params}
                InputProps={{
                  ...params.InputProps,
                  classes: {
                    root: classes.textInputStyle,
                  },
                }}
                placeholder={'Select Hip Size'}
                errorMessage={isRequired('hip_size') && !form.values.statistics?.hip_size ? 'Hip size is required' : ''}
              />
            )}
          />
        </div>
      )}
      {show('dress_size') && (
        <div>
          <CompCardButton
            attributes={{ label: 'Dress Size', key: 'dress_size' }}
            onClick={compCardAdd}
            hasValue={form.values.statistics?.dress_size !== '' && form.values.statistics?.dress_size !== null}
          />
          <Autocomplete
            filterOptions={filterOptions}
            onChange={(e, newValue, reason) => {
              if (compCardRemove && reason === 'clear') {
                compCardRemove({ key: 'dress_size' });
              }
              form.setFieldValue('statistics.dress_size', newValue);
            }}
            value={form.values.statistics?.dress_size}
            options={dresssize.map((j) => j.value)}
            getOptionSelected={(option, value) => option === value}
            fullWidth
            classes={{
              option: classes.option,
            }}
            renderInput={(params) => (
              <TextInput
                {...params}
                InputProps={{
                  ...params.InputProps,
                  classes: {
                    root: classes.textInputStyle,
                  },
                }}
                placeholder={'Select Dress Size'}
                errorMessage={
                  isRequired('dress_size') && !form.values.statistics?.dress_size ? 'Dress size is required' : ''
                }
              />
            )}
          />
        </div>
      )}
      {show('suit_size') &&
        (form.values.country === 'Australia' ? (
          <div>
            <CompCardButton
              attributes={{ label: 'Suit Size', key: 'suit_size' }}
              onClick={compCardAdd}
              hasValue={form.values.statistics?.suit_size !== '' && form.values.statistics?.suit_size !== null}
            />
            <Autocomplete
              filterOptions={filterOptions}
              onChange={(e, newValue, reason) => {
                if (compCardRemove && reason === 'clear') {
                  compCardRemove({ key: 'suit_size' });
                }
                form.setFieldValue('statistics.suit_size', newValue);
              }}
              value={form.values.statistics?.suit_size}
              options={suitSize.map((j) => j.value)}
              getOptionSelected={(option, value) => option === value}
              fullWidth
              classes={{
                option: classes.option,
              }}
              renderInput={(params) => (
                <TextInput
                  {...params}
                  InputProps={{
                    ...params.InputProps,
                    classes: {
                      root: classes.textInputStyle,
                    },
                  }}
                  placeholder={'Select Suit Size'}
                  errorMessage={
                    isRequired('suit_size') && !form.values.statistics?.suit_size ? 'Suit size is required' : ''
                  }
                />
              )}
            />
          </div>
        ) : (
          <></>
        ))}
      {show('coat_size') &&
        (form.values.country !== 'Australia' ? (
          <div>
            <CompCardButton
              attributes={{ label: 'Coat Size', key: 'coat_size' }}
              onClick={compCardAdd}
              hasValue={form.values.statistics?.coat_size !== '' && form.values.statistics?.coat_size !== null}
            />
            <Autocomplete
              id="SC-coatSize"
              filterOptions={filterOptions}
              onChange={(e, newValue, reason) => {
                if (compCardRemove && reason === 'clear') {
                  compCardRemove({ key: 'coat_size' });
                }
                form.setFieldValue('statistics.coat_size', newValue);
              }}
              value={form.values.statistics?.coat_size}
              options={coat.map((j) => j.value)}
              getOptionSelected={(option, value) => option === value}
              fullWidth
              classes={{
                option: classes.option,
              }}
              renderInput={(params) => (
                <TextInput
                  {...params}
                  InputProps={{
                    ...params.InputProps,
                    classes: {
                      root: classes.textInputStyle,
                    },
                  }}
                  placeholder={'Select Coat Size'}
                  errorMessage={
                    isRequired('coat_size') && !form.values.statistics?.coat_size ? 'Coat size is required' : ''
                  }
                />
              )}
            />
          </div>
        ) : (
          <></>
        ))}
    </React.Fragment>
  );
};

export default NonBinary;
